import { AttachLinkModalProps } from './AttachLinkModal';
import { openModal } from '@core/components/ModalStack';

export async function openAttachLinkModal(props: AttachLinkModalProps) {
  const { AttachLinkModal } = await import('./AttachLinkModal');

  openModal(AttachLinkModal, props);
}
